export default __webpack_public_path__ + "b6aab3a79b0bbd1f05fba8b7a27e7a48.svg";